import { loadCss } from 'app/common/utils/RouterUtils';

const routes = {
  '/oss': {
    fetch: () =>
      Promise.all([
        import(
          /* webpackChunkName: 'opensource-route' */ 'app/opensource/asyncRoute'
        ),
        loadCss([
          'https://cdn.rawgit.com/konpa/devicon/df6431e323547add1b4cf45992913f15286456d3/devicon.min.css',
        ]),
      ]).then(([module]) => module.default),
  },
};

export default routes;
